import * as BrandIcons from './brand';
import * as DuotoneIcons from './duotone';
import * as LightIcons from './light';
import * as RegularIcons from './regular';
import * as SolidIcons from './solid';

export default [DuotoneIcons, SolidIcons, RegularIcons, BrandIcons, LightIcons];
